import Phaser from "phaser";

const LOGICAL_HEIGHT = 1080;

export function initUiScale(game: Phaser.Game): void {
  const apply = (height: number) => {
    const h = height > 0 ? height : LOGICAL_HEIGHT;
    document.documentElement.style.setProperty("--ui-scale", String(h / LOGICAL_HEIGHT));
  };

  apply(game.scale.displaySize.height);

  game.scale.on(
    Phaser.Scale.Events.RESIZE,
    (_gameSize: Phaser.Structs.Size, _baseSize: Phaser.Structs.Size, displaySize: Phaser.Structs.Size) => {
      apply(displaySize.height);
    },
  );
}
